import { createUseStyles } from "react-jss";

export default createUseStyles((theme: any) => ({
    checkBox: {
        display: "inline-block",
        userSelect: "none",
        background: "transparent",
    },
    checkBoxGridCell: {
        composes: "check-box__grid-cell",
        display: "flex",
        height: theme.GridCellMinHeight,
        margin: -theme.GridCellPadding,
        alignItems: "center",
        justifyContent: "center",

        "&:hover, &:focus": {
            color: theme.PrimaryColor,
        },
    },
    checkBoxGridCellChecked: {
        composes: "check-box__grid-cell--checked",
        color: theme.PrimaryColor,
    },
    checkBoxInput: {
        composes: "check-box__input",
        display: "none",
    },
}));
